import { Box, Button } from "@mui/material";
import map from "../lep_map_newest2.png";
import { useReactToPrint } from "react-to-print";
import { useLayoutEffect, useRef } from "react";

export const ParkMap = () => {

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  useLayoutEffect(() => {
    window.scrollTo(0,0);
  });

  return (
    <div sx={{ background: "blue" }} align="center">
      <img src={map} ref={contentRef} alt="park map"></img>
      <Button color="secondary" sx={{display: "block"}} variant="contained" onClick={() => reactToPrintFn()}>Print</Button>
    </div>
  );
};
